export var getDisplayCategory = function getDisplayCategory(status) {
  return !status || status !== 'not_found' ? 'smartLink' : 'link';
};